export default __webpack_public_path__ + "static/media/openness3Img1.36ba71d3.png";